"use strict";

exports.__esModule = true;
exports["default"] = exports.INITIAL_STATE = void 0;

var _fetchWixData = require("./fetch-wix-data");

var _setWixData = require("./set-wix-data");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var INITIAL_STATE = {};
exports.INITIAL_STATE = INITIAL_STATE;

var wixData = function wixData(state, action) {
  if (state === void 0) {
    state = INITIAL_STATE;
  }

  switch (action.type) {
    case _fetchWixData.FETCH_WIX_DATA_SUCCESS:
    case _setWixData.SET_WIX_DATA_SUCCESS:
      return _objectSpread(_objectSpread({}, state), action.payload);

    default:
      return state;
  }
};

var _default = wixData;
exports["default"] = _default;